<template>
  <div class="bundle-products-wrapper">
      <div class="row">
          <div class="col-md-12">
              <table class="table table-hover bundleProducts tableBody">
                  <thead>
                      <tr>
                          <th class="w-150px">#Sr</th>
                          <th class="w-250px">Name</th>
                          <th class="w-350px" v-if="!(store.getters.role =='customer-contact' && store.getters.brand.hide_sku_on_shop=='1')">SKU</th>
                          <th class="w-50px">Quantity</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(productBundle,index) in productBundles" :key="index">
                          <td scope="row">{{index+1}}</td>
                            <td>
                                <a v-if="['customer-contact'].includes(store.getters.role)" href="javascript:void(0)" 
                                    @click="openProductDetailModal(productBundle.product)" data-toggle="modal" data-target="#productDetailModal">
                                    <img v-if="productBundle?.formatted_images?.default_image" :src="getBrandImageUrl(productBundle.formatted_images?.default_image)" alt="productImg" height="30" width="30" />
                                    <img v-else :src="'/images/no-image-500x500.jpg'" alt="productImg" height="30" width="30" />
                                {{productBundle.name}}
                                </a>
                            </td>
                          <td v-if="!(store.getters.role =='customer-contact' && store.getters.brand.hide_sku_on_shop=='1')">{{productBundle.SKU}}</td>
                          <td>{{productBundle.selection_qty}}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
    <!-- begin::Product View Modal -->
    <div class="modal fade" id="productDetailModal" tabindex="-1" role="dialog" aria-labelledby="productDetailModal" aria-modal="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="card card-custom">
                        <div class="card-body">
                            <ul class="nav nav-tabs nav-tabs-line nav-tabs-line-right nav-cursor">
                                <a class="nav-link  font-weight-bolder" @click="showTab=1;activeTab='Details'"  :class="[activeTab==='Details' ? 'active' : '']">{{$t('details')}}</a>
                                <a class="nav-link  font-weight-bolder" @click="showTab=2;activeTab='Gallery'"  v-if="product?.formatted_images" :class="[activeTab==='Gallery' ? 'active' : '']">{{$t('gallery')}}</a>
                                <a class="nav-link  font-weight-bolder" @click="showTab=2;activeTab='Gallery'" v-else-if="open_product_from_order && defualtImageExistance" :class="[activeTab==='Gallery' ? 'active' : '']">{{$t('gallery')}}</a>
                                <a class="nav-link  font-weight-bolder" @click="showTab=3;activeTab='Variants'" v-if="product?.variants && product.variants.length"  :class="[activeTab==='Variants' ? 'active' : '']">{{$t('variants')}}</a>
                            </ul>
                            <ul class="float-right" style="margin-top: -45px;" type="none">
                                <li class="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel nav-item">
                                    <button type="button" class="btn btn-clean btn-sm btn-icon btn-icon-md pull-right" @click="closeProductDetailModal" >
                                        <i class="flaticon2-cross"></i>
                                    </button>
                                </li>
                            </ul>
                            <div v-if="showTab===1">  <ProductDetails :key="componentKey" :selected-variant="variant" :product="product" :settings="settings" :show_product_details="product_details" :open_product_from_order="open_product_from_order" :msrp="msrp"></ProductDetails></div>
                            <div v-if="showTab===2 && imagesExistance && defualtImageExistance"><ProductImages :key="componentKey" :product="product" :show_product_details="product_details"></ProductImages></div>
                            <div v-if="showTab === 3 && product?.value?.variants?.length"><VariantListing :key="componentKey" :productVariants="product.value?.variants" :settings="settings" :track_inventory="product.value?.settings?.show_inventory" :retail_price="product.value?.settings?.show_retail_price_to_customers" :msrpName="product.value?.msrpDisplayName" /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END::Product View Modal -->
  </div>
</template>

<script setup>
import ProductDetails from './product-details.vue';
import VariantListing from './variants-listing.vue';
import ProductImages from './product-images.vue';
import {ref, defineProps, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { getBrandImageUrl } from '@/js/utils/common.js';
const store = useStore();
import { useI18n } from 'vue-i18n'; 
const { t } = useI18n();


const props = defineProps({
        productBundles : {
            type: Array,
            required: true,
        },
        settings: {
            type: Object,
            required : false,
        },
        product_details : {
            type: Boolean,
            required : true,
        },
        msrp: {
            type: String,
            required : false,
        },
        variant: {
            type: String,
            required: false,
        }
    });

const product = reactive({
  settings: {}
});

const showTab = ref(1);
const activeTab = ref('Details');
const open_product_from_order = ref(false);
const componentKey = ref(0);
const APIURL = import.meta.env.VITE_API_URL;


const imagesExistance = computed(() => {
  return  product?.formatted_images?.images?.length > 0 ? true : false;
});

const defualtImageExistance = computed(() => {
    return product?.formatted_images?.default_image ? true : false;
});

const openProductDetailModal = (selectedProduct) => {
  componentKey.value += 1;
  Object.assign(product, selectedProduct);
};

const closeProductDetailModal = () => {
    showTab.value = 1;
    activeTab.value = 'Details';
    $('#productDetailModal').modal('hide');
};

</script>

<style scoped>
.bundleProducts thead > tr > th {
    text-align: left;
}
.tableBody{
    height:500px;
    overflow-y:scroll;
    display: block;
}
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

@media (max-width: 600px) {
  .bundle-products-wrapper,
  .bundle-products-wrapper > .row,
  .bundle-products-wrapper > .row > .col-md-12,
  .bundle-products-wrapper .bundleProducts {
    width: 100% !important;
    min-width: 0;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .bundle-products-wrapper > .row {
    display: block;
    margin-right: 0;
    margin-left: 0;
  }
  .bundle-products-wrapper > .row > .col-md-12 {
    display: block;
    flex: 0 0 100%;
    padding-right: 0;
    padding-left: 0;
  }
  .bundle-products-wrapper .tableBody {
    display: table;
    height: auto;
    overflow: visible;
    table-layout: fixed;
  }
  .bundle-products-wrapper .bundleProducts th,
  .bundle-products-wrapper .bundleProducts td {
    width: auto !important;
    max-width: none !important;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    white-space: normal;
    overflow-wrap: anywhere;
  }
}
</style>